module.exports = __webpack_public_path__ + "img/hdgz.36cad7ec.jpg";